
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { usePlacesWidget } from 'react-google-autocomplete';
import { Editor } from 'react-draft-wysiwyg';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

export default function EventInfoForm({
  name, 
  startDate, 
  endDate, 
  venueName,
  venueAddress,
  flyerImage,
  setName,
  setStartDate,
  setEndDate,
  setVenueName,
  setVenueAddress,
  setFlyerImage,
  description,
  setDescription}) {

  const [startDateValid, setStartDateValid] = useState(true);
  const [endDateValid, setEndDateValid] = useState(true);

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => {
      console.log(place['formatted_address'])
      setVenueAddress(place['formatted_address'])
    },
    options: {
      types: ["address"],
    }    
  })

  // Helper function to convert datetime string to Date object for comparison
  const toDateTime = (dateTimeString) => {
    return new Date(dateTimeString);
  };

  
  return (
    <Form>
      <Form.Group className="mb-3" controlId="eventName">
        <Form.Label>Event name</Form.Label>
        <Form.Control 
          type="text" 
          placeholder="My Event Name" 
          defaultValue={name}
          onChange={(e)=>{setName(e.target.value)}}
          />
      </Form.Group>
      <Row>
        <Col>
          <Form.Group className="mb-3" controlId="eventStartDate">
            <Form.Label>Start</Form.Label>
            <Form.Control 
              type="datetime-local"
              defaultValue={startDate}
              min={new Date().toISOString().slice(0, 16)} // Set min date to now
              onChange={(e) => {
                const newDate = e.target.value;
                const newDateObj = new Date(newDate);
                const today = new Date();
                today.setHours(0, 0, 0, 0); // Set to midnight
                if (newDateObj <= today) {   
                  setStartDate(null);
                  setStartDateValid(false);
                  return;
                }
                setStartDate(newDate);
                setStartDateValid(true);
              }}/>
          </Form.Group>
          {!startDateValid && (
            <p className="text-danger">Start date must be after today.</p>
          )}
        </Col>
        <Col>
          <Form.Group className="mb-3" controlId="eventEndDate">
            <Form.Label>End date</Form.Label>
            <Form.Control 
              type="datetime-local"
              defaultValue={endDate}
              min={toDateTime(startDate).toISOString().slice(0, 16)} // Set min date to now
              onChange={(e) => {
                const newEndDate = e.target.value;
                if (startDate && newEndDate) {
                  const start = toDateTime(startDate);
                  const end = toDateTime(newEndDate);
                  if (end < start) {
                    // If end date-time is less than start date-time, set endDate to null
                    setEndDate(null);
                    setEndDateValid(false);
                    return;
                  }
                }
                setEndDate(newEndDate);
                setEndDateValid(true);
              }}
            />
          </Form.Group>
          {!endDateValid && (
            <p className="text-danger">End date must be after start date.</p>
          )}
        </Col>
      </Row>
      <Form.Group className="mb-3" controlId="eventVenueAddress">
        <Form.Label>Venue address</Form.Label>
        <Form.Control 
          type="text" 
          placeholder="Venue Address" 
          defaultValue={venueAddress}
          ref={ref}
          // onChange={(e)=>{setVenueAddress(e.target.value)}}
          />
      </Form.Group>
      <Form.Group className='mb-3'>
        <Form.Label>Description</Form.Label>
        <Editor
          wrapperClassName="event-description-wrapper"
          editorClassName="event-description-editor"
          onEditorStateChange={setDescription}
          editorState={description}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="eventFlyerImage">
        <Form.Label>Flyer image</Form.Label>
        <Form.Control type="file" defaultValue={flyerImage} onChange={(e)=>{setFlyerImage(e.target.files)}}/>
      </Form.Group>
    </Form>
  );
}
